export const AIRBRAKE_PROJECT_KEY = process.env.NEXT_PUBLIC_AIRBRAKE_KEY;
export const AIRBRAKE_PROJECT_ID = process.env.NEXT_PUBLIC_AIRBRAKE_ID;
export const APP_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const APP_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const APP_NODE_ENV = process.env.NODE_ENV;
export const GTM_SCRIPT_ID = process.env.NEXT_PUBLIC_GTM_SCRIPT_ID;
export const LAUNCH_DARKYLY_CLIENT_ID = process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_SIDE_ID;
export const ORDER_SERVICE_API_BASE_URL = process.env.NEXT_PUBLIC_SM_API_HOST;
export const ORDER_SERVICE_API_URL = `${ORDER_SERVICE_API_BASE_URL}/api/v1/ams`;
export const PRODUCT_SERVICE_GRAPHQL_API_BASE_URL =
  process.env.NEXT_PUBLIC_PRODUCTS_GRAPHQL_API_BASE_URL;
export const REWARDS_FRONTEND_URL = process.env.NEXT_PUBLIC_STADIUM_REWARDS_URL;
export const REWARDS_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_REWARDS_API_BASE_URL;
export const PUBNUB_PUBLISH_KEY = process.env.NEXT_PUBLIC_PUBNUB_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = process.env.NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY;
export const SEARCH_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_SEARCH_API_BASE_URL;
export const USERS_FRONTEND_URL = process.env.NEXT_PUBLIC_STADIUM_USERS_URL;
export const USER_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_USER_SERVICE_API_BASE_URL;
export const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY;
export const ZENDESK_KEY = process.env.NEXT_PUBLIC_ZENDESK_KEY;

export const SHOPS_DASHBOARD_HOSTNAME = process.env.NEXT_PUBLIC_SHOPS_DASHBOARD_HOSTNAME;
